<template>
	<div class="about">
		<div class="pg-header">
			<div>
				<label class="title">医生工作量统计</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>统计管理</span>|
					<span>工作量统计</span>|
					<span>门诊排期统计</span>|
					<span v-text="depName"></span>
				</div>
				<a class="back noline" @click="goBack">返回</a>
			</div>
		</div>

		<div class="collapse-wrap">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<label>就诊日期
							<el-date-picker size="small" style="width:220px" type="daterange" align="right"
								unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
								v-model="filter.date" :picker-options="pickerOptions"
								@change="handleFilter(0, $event)"></el-date-picker>
						</label>
						<div style="display: inline-block;">医生
							<el-select size="small" filterable clearable v-model="filter.docId" placeholder="请选择"
								@change="handleFilter(1, $event)">
								<el-option v-for="item in doctorList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<el-button size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
						<el-button v-if="permission" class="btn-export flr" size="mini" round @click="exportReport"><i
								class="icon-export" style="margin-right: 10px;"></i>导出</el-button>
					</div>
				</el-form>
			</div>

			<div class="table-wrap">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					show-summary :summary-method="getSummaries" :data="list.data" v-loading="isLoading"
					@selection-change="selectionChange">
					<el-table-column label="科室" prop="depName" width="280"></el-table-column>
					<el-table-column prop="docName" label="科室医生"></el-table-column>
					<el-table-column prop="outHospitalTotal" label="出院人次"></el-table-column>
					<el-table-column prop="notScheduledTotal" label="未排期人次"></el-table-column>
					<el-table-column prop="scheduledTotal" label="已排期人次"></el-table-column>
					<el-table-column prop="doNotVisitTotal" label="勿访人次"></el-table-column>
					<el-table-column>
						<template slot="header">
							已排期率
							<img @click="openModal('header')" class="t-img" src="../../assets/images/question-fill.png" alt="">
						</template>
						<template slot-scope="scope">
							<span>{{ scope.row.scheduleRate}}</span>
							<img  @click="openModal('column',scope.row)" class="t-img" src="../../assets/images/question-fill.png" alt="">
						</template>
					</el-table-column>
					<el-table-column>
						<template slot="header">
							勿访率
							<img @click="openModal('header2')" class="t-img" src="../../assets/images/question-fill.png" alt="">
						</template>
						<template slot-scope="scope">
							<span>{{ scope.row.doNotVisitRate}}</span>
							<img  @click="openModal('column2',scope.row)" class="t-img" src="../../assets/images/question-fill.png" alt="">
						</template>
					</el-table-column>
					<el-table-column prop="notscheduledOverdueTotal" label="过期待排人次"></el-table-column>
					<el-table-column prop="scheduledOverdueTotal" label="过期已排人次"></el-table-column>
					<el-table-column prop="doNotVisitOverdueTotal" label="过期勿访人次"></el-table-column>
					<el-table-column>
						<template slot="header">
							已排期及时率
							<img @click="openModal('header1')" class="t-img" src="../../assets/images/question-fill.png" alt="">
						</template>
						<template slot-scope="scope">
							<span>{{ scope.row.timelySchedulingRate}}</span>
							<img  @click="openModal('column1',scope.row)" class="t-img" src="../../assets/images/question-fill.png" alt="">
						</template>
					</el-table-column>
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span
									v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span
									v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据
							</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
								:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
								:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
								@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>

		</div>
		<ModalCommon :dlg.sync="dlg" v-if="dlg.visible" />

	</div>
</template>

<script>
	import api from '@/service/api.js';
	import mixin from '@/views/mixin';
	import dayjs from 'dayjs';
	import ModalCommon from './components/modalCommon.vue';
	import questionFillImg from '@/assets/images/question-fill.png';

	export default {
		mixins: [mixin],
		components:{ModalCommon},
		data() {
			return {
				list: {
					current: 1,
					total: 0,
					pageSize: 0,
					data: null,
					summary: []
				},
				filter: {
					recordTimeStart: '',
					recordTimeEnd: '',
					depId: '',
					docId: '',
					pageNumber: 1,
					pageSize: 10
				},
				depName: '',
				doctorList: [],
				permission: false,
				isLoading:false,
				dlg:{
					visible:false,
					type:'',
					propname:'schedule',
					data:{}
				},
			}
		},
		created() {
			this.filter.depId = this.$route.query.depId;
			this.loadList();
			// 获取 医生下拉
			api.getUserList({
				roleId: 2,
				pageNumber: 1,
				pageSize: 99999,
				depIds: this.filter.depId
			}).then((res) => {
				if (res.code == 1000 && res.data) {
					this.doctorList = res.data;
				}
			})
		},
		methods: {
			async loadList() {
				this.isLoading = true;
				let res = await api.getOutpatientDocList(this.filter);
				if (res.code == 500) {
					return this.$router.push({
						name: 'Login',
						query: {
							r: location.href
						}
					});
				}
				this.depName = res.data.depName;

				this.list.total = +res.total;
				this.list.current = this.filter.pageNumber;
				this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
				if (res.code == 1000 && res.data) {
					this.list.summary = ['合计', '', res.data.sum.outHospitalTotal, res.data.sum.notScheduledTotal, res.data.sum.scheduledTotal, res.data.sum.doNotVisitTotal,res.data.sum.scheduleRate,res.data.sum.doNotVisitRate, res.data.sum.notscheduledOverdueTotal,res.data.sum.scheduledOverdueTotal,res.data.sum.doNotVisitOverdueTotal, res.data.sum.timelySchedulingRate];
					this.list.data = res.data.list;
				}
				// 权限控制
				this.user = JSON.parse(localStorage.getItem('user')).data;
				this.permission = (this.user.user.roleId == "6" || this.user.user.roleId == "1") ? true : false;
				this.isLoading = false;
			},
			getSummaries() {
				if (this.$refs['multipleTable']) {
					let current = this.$refs['multipleTable']
					let tbodyElement = current.$el.querySelector('tbody.has-gutter');
					if (tbodyElement) {
						let trElements = tbodyElement.querySelectorAll('tr');
						let img1=document.querySelector('.img1');
						let img2=document.querySelector('.img2');
						let img3=document.querySelector('.img3');
						trElements.forEach(tr => {
							let tdElements = tr.querySelectorAll('td');
							tdElements.forEach((td,index) => {
								let divElement = td.querySelector('.cell');
								if (divElement&&(index==6||index==11||index==7)&&!(img1||img2||img3)) {
									let imgElement = document.createElement('img');
									imgElement.src = questionFillImg;
									if (index == 6) {
										imgElement.className = 'img1';
										imgElement.addEventListener('click', () =>this.openSumModal('column'));
									} else if (index == 11) {
										imgElement.className = 'img2';
										imgElement.addEventListener('click', () =>this.openSumModal('column1'));
									} else if (index == 7) {
										imgElement.className = 'img3';
										imgElement.addEventListener('click', () =>this.openSumModal('column2'));
									}
									divElement.appendChild(imgElement);
								}
							});
			
						});
					} else {
						console.error('无法找到<tbody>元素！');
					}
				}
				this.$nextTick(() => {
					this.$refs['multipleTable'].doLayout();
				});
				return this.list.summary;
			},
			openSumModal(type){
				this.dlg.type=type;
				console.log(this.list.summary)
				this.dlg.data.outHospitalTotal=this.list.summary[2];// 出院人次
				this.dlg.data.scheduledTotal=this.list.summary[4];//已排期人次
				this.dlg.data.doNotVisitTotal=this.list.summary[5];//勿访人次
				this.dlg.data.scheduleRate=this.list.summary[6];//已排期率
				this.dlg.data.doNotVisitRate=this.list.summary[7];//勿访率
				this.dlg.data.scheduledOverdueTotal=this.list.summary[9];//过期待排期人次
				this.dlg.data.doNotVisitOverdueTotal=this.list.summary[10];//过期勿访人次
				this.dlg.data.timelySchedulingRate=this.list.summary[11];//已排期及时率
				this.dlg.visible = true;
			},
			// 过滤条件 更改
			handleFilter(key, val) {
				switch (key) {
					case 0:
						if (this.filter.date) {
							this.filter.recordTimeStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
							this.filter.recordTimeEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
						} else {
							this.filter.recordTimeStart = '';
							this.filter.recordTimeEnd = '';
						}
						break;
				}
				this.filter.pageNumber = 1;
				this.loadList();
			},
			handleSizeChange(v) {
				this.filter.pageSize = v;
				this.filter.pageNumber = 1;
				this.loadList();
			},
			handleCurrentChange(v) {
				this.filter.pageNumber = v;
				this.loadList();
			},
			exportReport() {
				this.filter.pageSize=this.list.total;
				let url = api.exportStatisticsDepartment2(this.filter);
				const tempLink = document.createElement('a');
				tempLink.style.display = 'none';
				tempLink.href = url;
				tempLink.target = '_blank';
				document.body.appendChild(tempLink);
				tempLink.click()
				document.body.removeChild(tempLink);
			this.filter.pageSize=10;

			},
			openModal(type,data){
				this.dlg.data = data;
				this.dlg.type = type;
				this.dlg.visible = true;
			}	
		}
	}
</script>

<style lang="less" scoped>
	@import '@/assets/style/var';
	@import './components/sty.less';
</style>